import React from 'react';
import ReactDOM from 'react-dom/client';
import './App.css';
import App from './App';
import { enregistrerSW, initNatif } from './push';
import { natif } from './plateforme';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  <React.StrictMode>
    <App />
  </React.StrictMode>
);

// Dans une application des stores, ni service worker ni vérification de version :
// les mises à jour passent par les stores ; les notifications, par Firebase.
if (natif) initNatif(); else enregistrerSW();
